import React, { createContext, useContext, useEffect, useState } from 'react'
import { getPeriodoMesAtual } from '../services/util/date.service'

const EstoqueContext = createContext()

const INITIAL_STATE = {
  inventario: {
    selectedPeriodo: getPeriodoMesAtual(),
    globalFilter: '',
  },
}

export const EstoqueContextProvider = ({ children }) => {
  const [estoqueContext, setEstoqueContext] = useState(INITIAL_STATE)
  const [inventarioContext, setInventarioContext] = useState(estoqueContext.inventario)

  return (
    <EstoqueContext.Provider
      value={{
        estoqueContext,
        setEstoqueContext,
        inventarioContext,
        setInventarioContext,
      }}
    >
      {children}
    </EstoqueContext.Provider>
  )
}

export const useEstoqueContext = () => {
  const { estoqueContext, setEstoqueContext } = useContext(EstoqueContext)
  return { estoqueContext, setEstoqueContext }
}

export const useInventarioContext = () => {
  const { setEstoqueContext } = useContext(EstoqueContext)
  const { inventarioContext, setInventarioContext } = useContext(EstoqueContext)

  useEffect(() => {
    setEstoqueContext(prevEstoqueContext => ({
      ...prevEstoqueContext,
      inventario: inventarioContext,
    }))
  }, [inventarioContext])

  return { inventarioContext, setInventarioContext }
}
